export default "__VITE_ASSET__CvkE48y0__"